
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { ReactiveFormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { NgxSpinnerModule } from 'ngx-spinner';
import { NgxImageCompressService } from 'ngx-image-compress';
import { ModalDialogModule } from '@preeco-privacy/ngx-modal-dialog';
import {
	MetaModule,
	MetaLoader,
	PageTitlePositioning,
	MetaStaticLoader,
} from '@ngx-meta/core';

import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';

import { MenuItems } from './shared/Menu/menu-items';
import { AdminMenuItems } from './shared/private-header/admin-menu-items';
import {
	FacebookLoginProvider,
	GoogleLoginProvider,
	SocialAuthServiceConfig,
	SocialLoginModule
} from 'angularx-social-login';
import { environment } from 'src/environments/environment';

export function metaFactory(): MetaLoader {
	return new MetaStaticLoader({
		pageTitlePositioning: PageTitlePositioning.PrependPageTitle,
		pageTitleSeparator: ' - ',
		applicationName: 'ToTT - aplikacja dla miłośników gór',
		defaults: {
			title: 'ToTT - aplikacja dla miłośników gór',
			description: 'Sprawdź naszą strone i dowiedz się więcej',
			'og:image': '../assets/image/about-image.jpg',
			'og:type': 'website',
			'og:locale': 'pl_PL',
		},
	});
}

@NgModule({
	declarations: [AppComponent],
	imports: [
		BrowserModule.withServerTransition({ appId: 'fasttrac-web' }),
		AppRoutingModule,
		BrowserAnimationsModule,
		CoreModule.forRoot(),
		ModalDialogModule.forRoot(),
		MetaModule.forRoot({
			provide: MetaLoader,
			useFactory: metaFactory,
		}),
		NgxSpinnerModule,
		SharedModule,
		HttpClientModule,
		ReactiveFormsModule,
		SocialLoginModule
	],
	providers: [
		MenuItems,
		AdminMenuItems,
		{ provide: LocationStrategy, useClass: PathLocationStrategy },
		NgxImageCompressService,
		{
			provide: 'SocialAuthServiceConfig',
			useValue: {
				autoLogin: false,
				providers: [
					{
						id: GoogleLoginProvider.PROVIDER_ID,
						provider: new GoogleLoginProvider(environment.socialLoginsProvidersClientIds.googleLoginProvider),
					},
					{
						id: FacebookLoginProvider.PROVIDER_ID,
						provider: new FacebookLoginProvider(environment.socialLoginsProvidersClientIds.facebookLoginProvider),
					}
				],
			} as SocialAuthServiceConfig,
		}
	],
	bootstrap: [AppComponent],
})
export class AppModule { }
